import { AxiosInstance } from "axios";
import httpClientFactory from "../config/httpConfig";

const APPLICATIONS_ENDPOINT = "applications";

interface IApplicationService {
  getApplicationLegal:(appId: string, locale: string, regionId: string) => Promise<any>;
}

const ApplicationService = (config: any): IApplicationService => {
  const http: AxiosInstance = httpClientFactory(config);

  return {
    getApplicationLegal: async (appId: string, locale: string, regionId: string) => {
      return await http.get(`/${APPLICATIONS_ENDPOINT}/${appId}/legal?locale=${locale}&region=${regionId}`);
    }
  };

};

export default ApplicationService;
